import { createRef } from 'react'

/**
 * Lives outside routes.tsx so that `utils/helpers` can navigate without
 * importing the route graph — that import made every barrel (`utils`,
 * `components`, `context`) cyclic with the whole app and produced dozens of
 * Rollup chunk-ordering warnings at build time.
 *
 * Populated by `RenderRoutes` on every render.
 */
export const historyRef: React.MutableRefObject<any> = createRef()
